function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg23(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.13 81.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.1,1.5c-.86.87-1.57,1.65-1.57,1.75s-.9,3.33-2.01,7.18c-1.11,3.85-2.66,12.85-3.46,20.01-.8,7.16-2.89,19.47-4.64,27.37-3.67,16.54-3.45,18.39,2.63,21.83,6.36,3.6,14.39,2.69,18.76-2.12,2.91-3.21,3.04-6.13.58-13.29-1.89-5.51-2.35-8.98-2.4-18.3-.1-17.37-1.57-42.27-2.61-44.25-1.14-2.17-3.21-2.24-5.28-.18",
    style: {
      fill: "#010101",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.87,10.18c.34,3.99.92,15.29,1.29,25.13l.68,17.88-3.9-.46c-2.15-.25-5.3-.15-7,.23l-3.1.69,1.27-6.11c.7-3.36,1.76-11.08,2.36-17.16.93-9.45,4.03-23.95,5.69-26.64,1.33-2.16,2.16-.19,2.73,6.43",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.22,61.43c3.05,8.36,2.98,12.82-.24,15.36-5.24,4.12-12.81,3.59-17.33-1.22-2.13-2.26-2.14-2.45-.63-9.72,1.93-9.32,3.77-11.13,10.93-10.71l5.08.3,2.19,6",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg23);
export default __webpack_public_path__ + "static/media/23.6c281fccb5fe77a080b47071a3f501d3.svg";
export { ForwardRef as ReactComponent };